// extracted by mini-css-extract-plugin
export default {"input":"input--e33aP","innerInput":"innerInput--Fio53","inputPaddingText":"inputPaddingText--vOnXk","inputPadding":"inputPadding--L_zN_","number":"number--Yte06"};